/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {updateEmail, updatePassword} from '../core/_models'
import {IUpdateEmail, IUpdatePassword, TUpdateEmailRequest} from '../../../coreGlobal/models/user'
import {
  emailFormValidationSchema,
  passwordFormValidationSchema,
} from '../validate/confirmProfileDetailsSchema'
import {BuildRequest} from '../core/BuildRequest'
import Swal from 'sweetalert2'
import {putProfileChangeEmail, putProfileChangePassword} from '../core/_requests'
import {BuildRequestPassword} from '../core/BuildRequestPassword'
import {useNavigate} from 'react-router-dom'

type Props = {
  email: string
}

const SignInMethod: React.FC<Props> = ({email}) => {
  const [emailUpdateData, setEmailUpdateData] = useState<IUpdateEmail>(updateEmail)
  const [passwordUpdateData, setPasswordUpdateData] = useState<IUpdatePassword>(updatePassword)

  const [showEmailForm, setShowEmailForm] = useState<boolean>(false)
  const [showPasswordForm, setPasswordForm] = useState<boolean>(false)

  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  })

  const togglePassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }))
  }

  const [loading1, setLoading1] = useState(false)
  const navigate = useNavigate()

  const formik1 = useFormik<IUpdateEmail>({
    initialValues: {
      ...emailUpdateData,
    },
    validationSchema: emailFormValidationSchema,
    onSubmit: async (values) => {
      const newValues = await BuildRequest(values)
      submit1(newValues)
    },
  })

  const submit1 = async (data: TUpdateEmailRequest) => {
    await Swal.fire({
      title: 'Deseja atualizar o e-mail?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
        cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading1(true)
        try {
          await putProfileChangeEmail(data)
          await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Salvo com sucesso',
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
              cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
            },
          })

          navigate(0)
        } catch (error: any) {
          await Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            customClass: {
              confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
              cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
            },
          })
        } finally {
          setLoading1(false)
        }
      }
    })
  }

  const [loading2, setLoading2] = useState(false)

  const formik2 = useFormik<IUpdatePassword>({
    initialValues: {
      ...passwordUpdateData,
    },
    validationSchema: passwordFormValidationSchema,
    onSubmit: async (values) => {
      const newValues = await BuildRequestPassword(values)

      setLoading2(true)
      try {
        await putProfileChangePassword(newValues)
        await Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Salvo com sucesso',
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
            cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
          },
        })
      } catch (error: any) {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response.data.message,
          customClass: {
            confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
            cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
          },
        })
      } finally {
        setLoading2(false)
      }
    },
  })

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Método de login</h3>
        </div>
      </div>

      <div className='card-body border-top p-9'>
        <div className='d-flex flex-wrap align-items-center'>
          <div id='kt_signin_email' className={' ' + (showEmailForm && 'd-none')}>
            <div className='fs-6 fw-bolder mb-1'>Endereço de e-mail</div>
            <div className='fw-bold text-gray-600'>{email}</div>
          </div>

          <div
            id='kt_signin_email_edit'
            className={'flex-row-fluid ' + (!showEmailForm && 'd-none')}
          >
            <form
              onSubmit={formik1.handleSubmit}
              id='kt_signin_change_email'
              className='form'
              noValidate
            >
              <div className='row mb-6'>
                <div className='col-lg-6 mb-4 mb-lg-0'>
                  <div className='fv-row mb-0'>
                    <label htmlFor='emailaddress' className='form-label fs-6 fw-bolder mb-3'>
                      Insira o novo endereço de e-mail
                    </label>
                    <input
                      type='email'
                      className='form-control form-control-lg form-control-solid'
                      id='emailaddress'
                      placeholder='Endereço de e-mail'
                      autoComplete='emailaddress'
                      {...formik1.getFieldProps('newEmail')}
                    />
                    {formik1.errors.newEmail && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik1.errors.newEmail}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-lg-6'>
                  <div className='fv-row mb-0'>
                    <label
                      htmlFor='confirmemailpassword'
                      className='form-label fs-6 fw-bolder mb-3'
                    >
                      Confirme sua senha
                    </label>
                    <input
                      type='password'
                      className='form-control form-control-lg form-control-solid'
                      id='confirmemailpassword'
                      autoComplete='confirmemail-password'
                      {...formik1.getFieldProps('confirmPassword')}
                    />
                    {formik1.errors.confirmPassword && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik1.errors.confirmPassword}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='d-flex'>
                <button
                  id='kt_signin_submit'
                  type='submit'
                  className='btn btn-danger  me-2 px-6'
                  disabled={loading1 || !formik1.isValid}
                >
                  {!loading1 && 'Atualizar e-mail'}
                  {loading1 && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Por favor, aguarde...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
                <button
                  id='kt_signin_cancel'
                  type='button'
                  onClick={() => {
                    setShowEmailForm(false)
                  }}
                  className='btn btn-color-gray-400 btn-active-light-danger px-6'
                  disabled={loading1 || !formik1.isValid}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>

          <div id='kt_signin_email_button' className={'ms-auto ' + (showEmailForm && 'd-none')}>
            <button
              onClick={() => {
                setShowEmailForm(true)
              }}
              className='btn btn-light btn-active-light-danger'
            >
              Alterar e-mail
            </button>
          </div>
        </div>

        <div className='separator separator-dashed my-6'></div>

        <div className='d-flex flex-wrap align-items-center mb-10'>
          <div id='kt_signin_password' className={' ' + (showPasswordForm && 'd-none')}>
            <div className='fs-6 fw-bolder mb-1'>Senha</div>
            <div className='fw-bold text-gray-600'>************</div>
          </div>

          <div
            id='kt_signin_password_edit'
            className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
          >
            <form
              onSubmit={formik2.handleSubmit}
              id='kt_signin_change_password'
              className='form'
              noValidate
            >
              <div className='row mb-1'>
                <div className='col-lg-4'>
                  <div className='fv-row mb-0'>
                    <label htmlFor='currentpassword' className='form-label fs-6 fw-bolder mb-3'>
                      Senha atual
                    </label>
                    <div className='position-relative'>
                      <input
                        type={showPassword.current ? 'text' : 'password'}
                        className='form-control form-control-lg form-control-solid pe-10'
                        id='currentpassword'
                        autoComplete='current-password'
                        {...formik2.getFieldProps('currentPassword')}
                      />
                      <button
                        type='button'
                        onClick={() => togglePassword('current')}
                        className='btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-4'
                      >
                        {showPassword.current ? (
                          <i className='ki-duotone ki-eye-slash'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                            <span className='path4'></span>
                          </i>
                        ) : (
                          <i className='ki-duotone ki-eye'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                          </i>
                        )}
                      </button>
                    </div>
                    {formik2.errors.currentPassword && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik2.errors.currentPassword}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <div className='fv-row mb-0'>
                    <label htmlFor='newpassword' className='form-label fs-6 fw-bolder mb-3'>
                      Nova senha
                    </label>

                    <div className='position-relative'>
                      <input
                        type={showPassword.new ? 'text' : 'password'}
                        className='form-control form-control-lg form-control-solid pe-10'
                        id='newpassword'
                        autoComplete='new-password'
                        {...formik2.getFieldProps('newPassword')}
                      />

                      <button
                        type='button'
                        onClick={() => togglePassword('new')}
                        className='btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-4'
                      >
                        {showPassword.new ? (
                          <i className='ki-duotone ki-eye-slash'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                            <span className='path4'></span>
                          </i>
                        ) : (
                          <i className='ki-duotone ki-eye'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                          </i>
                        )}
                      </button>
                    </div>

                    {formik2.errors.newPassword && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik2.errors.newPassword}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <div className='fv-row mb-0'>
                    <label htmlFor='confirmpassword' className='form-label fs-6 fw-bolder mb-3'>
                      Confirme a nova senha
                    </label>
                    <div className='position-relative'>
                      <input
                        type={showPassword.confirm ? 'text' : 'password'}
                        className='form-control form-control-lg form-control-solid pe-10'
                        id='confirmpassword'
                        autoComplete='confirmpassword'
                        {...formik2.getFieldProps('passwordConfirmation')}
                      />

                      <button
                        type='button'
                        onClick={() => togglePassword('confirm')}
                        className='btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-4'
                      >
                        {showPassword.confirm ? (
                          <i className='ki-duotone ki-eye-slash'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                            <span className='path4'></span>
                          </i>
                        ) : (
                          <i className='ki-duotone ki-eye'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                          </i>
                        )}
                      </button>
                    </div>
                    {formik2.errors.passwordConfirmation && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik2.errors.passwordConfirmation}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className='form-text mb-5'>
                <p>A senha deve ter pelo menos 6 caracteres.</p>
                <p>A senha deve conter pelo menos uma letra maiúscula.</p>
                <p>A senha deve conter pelo menos uma letra minúscula.</p>
                <p>A senha deve conter pelo menos um dígito(Ex: 1,2.3......9).</p>
                <p>A senha deve conter pelo menos um caractere especial(Ex: !@#$%).</p>
              </div>

              <div className='d-flex'>
                <button
                  id='kt_password_submit'
                  type='submit'
                  className='btn btn-danger me-2 px-6'
                  disabled={loading2 || !formik2.isValid}
                >
                  {!loading2 && 'Atualizar Senha'}

                  {loading2 && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Por favor, aguarde...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
                <button
                  onClick={() => {
                    setPasswordForm(false)
                  }}
                  id='kt_password_cancel'
                  type='button'
                  className='btn btn-color-gray-400 btn-active-light-danger px-6'
                  disabled={loading2 || !formik2.isValid}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>

          <div
            id='kt_signin_password_button'
            className={'ms-auto ' + (showPasswordForm && 'd-none')}
          >
            <button
              onClick={() => {
                setPasswordForm(true)
              }}
              className='btn btn-light btn-active-light-danger'
            >
              Redefinir senha
            </button>
          </div>
        </div>

        {/* <div className='notice d-flex bg-light-danger rounded border-danger border border-dashed p-6'>
            <KTIcon iconName='shield-tick' className='fs-2tx text-danger me-4' />
            <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
              <div className='mb-3 mb-md-0 fw-bold'>
                <h4 className='text-gray-800 fw-bolder'>Proteja sua conta</h4>
                <div className='fs-6 text-gray-600 pe-7'>
                  A autenticação de dois fatores adiciona uma camada extra de segurança à sua conta.
                  Para fazer login, você também precisará fornecer um código de 6 dígitos.
                </div>
              </div>
              <a
                href='#'
                className='btn btn-danger px-6 align-self-center text-nowrap'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_two_factor_authentication'
              >
                Habilitar
              </a>
            </div>
          </div> */}
      </div>
    </div>
  )
}

export {SignInMethod}
